export default __webpack_public_path__ + "static/media/no-referrals.630eae37.png";